"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.options = exports.default = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _AnimatedGraphs = _interopRequireDefault(require("./AnimatedGraphs.json"));
var _chart = require("chart.js");
var _reactChartjs = require("react-chartjs-2");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
_chart.Chart.register(_chart.CategoryScale, _chart.LinearScale, _chart.BarElement, _chart.Title, _chart.Tooltip, _chart.Legend);
const options = exports.options = {
  plugins: {
    title: {
      display: true,
      text: "Stacked & Grouped Chart"
    }
  },
  responsive: true,
  interaction: {
    mode: "index",
    intersect: false
  },
  scales: {
    x: {
      stacked: true
    },
    y: {
      stacked: true
    }
  }
};
let containerStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
};
let chartStyling = {
  width: "80%",
  height: "80%"
};
let inputStyling = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginTop: "1%"
};
function App(_ref) {
  let {
    json,
    chartStyle
  } = _ref;
  json = json == "" || json == null || json == undefined ? _AnimatedGraphs.default : json;
  chartStyle = chartStyle == "" || chartStyle == null || chartStyle == undefined ? chartStyling : chartStyle;
  const [topping, setTopping] = (0, _react.useState)("stacked");
  const [userChoice, setUserChoice] = (0, _react.useState)(null); // User's radio button choice

  (0, _react.useEffect)(() => {
    const intervalId = setInterval(() => {
      if (userChoice === null) {
        setTopping(prevMode => prevMode === "stacked" ? "grouped" : "stacked");
      }
    }, 3000);
    return () => clearInterval(intervalId); // Cleanup on unmount
  }, [userChoice]);
  const onOptionChange = e => {
    setUserChoice(e.target.value);
    setTopping(e.target.value);
  };
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    style: inputStyling
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: "radio",
    id: "stacked",
    value: "stacked",
    name: "radioButton",
    checked: topping === "stacked",
    onChange: onOptionChange
  }), /*#__PURE__*/_react.default.createElement("label", {
    for: "stacked"
  }, "Stacked Chart"), /*#__PURE__*/_react.default.createElement("input", {
    type: "radio",
    id: "grouped",
    value: "grouped",
    name: "radioButton",
    checked: topping === "grouped",
    onChange: onOptionChange
  }), /*#__PURE__*/_react.default.createElement("label", {
    for: "grouped"
  }, "Grouped Chart")), /*#__PURE__*/_react.default.createElement("div", {
    style: containerStyle
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: chartStyle
  }, /*#__PURE__*/_react.default.createElement(_reactChartjs.Bar, {
    options: options,
    data: json[topping]
  }))));
}
var _default = exports.default = App; // Assign unique stack values to each dataset